/**
 * Parte da assinatura que pode correr no browser (sem node:crypto).
 */
/** Os 4 caracteres impressos no documento: posições 1, 11, 21 e 31 (base 1). */
export function printableHash(hash) {
    return [0, 10, 20, 30].map((i) => hash.charAt(i)).join('');
}
/**
 * Menção impressa: "AbCd - Processado por computador - Makila Facturação".
 * A lei pede "Processado por computador"; não exige dizer se o programa está
 * autorizado nem o n.º da autorização (esse fica gravado em cada documento).
 */
export function softwareMention(hash, softwareName) {
    const text = `Processado por computador - ${softwareName}`;
    return hash ? `${printableHash(hash)} - ${text}` : text;
}
//# sourceMappingURL=signature-print.js.map